import { useState, useEffect } from "react";
import "./SharePointPagesPicker.css";
import Modal from "../shared/Modal";
import { DriveResource, MSDrive, MSSite } from "winslow-core";
import { selectUser } from "../../redux/features/appData";
import { useSelector } from "react-redux";
import { MULTI_SELECT_KEY } from "../folder-picker/FolderPicker";

type SharePointPagesPickerProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelected: (pages: DriveResource[]) => void;
  msSite: MSSite | null;
  handleOpenSharepointPicker: () => void;
};

export const SharePointPagesPicker = ({
  isOpen,
  onClose,
  onSelected,
  msSite,
  handleOpenSharepointPicker,
}: SharePointPagesPickerProps) => {
  const storeUser = useSelector(selectUser);
  const [multiKeyDown, setMultiKeyDown] = useState<boolean>(false);
  const [selectedPages, setSelectedPages] = useState<string[]>([]);

  useEffect(() => {
    window.addEventListener("keydown", handleGlobalKeyDown);
    window.addEventListener("keyup", handleGlobalKeyUp);

    return () => {
      window.removeEventListener("keydown", handleGlobalKeyDown);
      window.removeEventListener("keyup", handleGlobalKeyUp);
    };
  }, []);

  const handleGlobalKeyDown = (e: any) => {
    console.log("GOT KEY: ", e.key);
    if (e.key === MULTI_SELECT_KEY) {
      setMultiKeyDown(true);
    }

    if (!multiKeyDown && (e.key === "a" || e.key === "A")) {
      selectAllPages();
      e.stopPropagation();
      e.preventDefault();
    }
  };

  const handleGlobalKeyUp = (e: any) => {
    if (e.key === MULTI_SELECT_KEY) {
      setMultiKeyDown(false);
    }
  };

  const pageIsSelected = (id: string) => {
    return (
      selectedPages.findIndex((fileId: string) => {
        return fileId === id;
      }) !== -1
    );
  };

  const selectPage = (id: string) => {
    const newSelectedPages = [...selectedPages];
    newSelectedPages.push(id);
    setSelectedPages(newSelectedPages);
  };

  const unselectPage = (id: string) => {
    const index = selectedPages.findIndex((fileId: string) => {
      return fileId === id;
    });

    if (index !== -1) {
      const newSelectedPages = [
        ...selectedPages.slice(0, index),
        ...selectedPages.slice(index + 1),
      ];
      setSelectedPages(newSelectedPages);
    }
  };

  const resetSelectedPagesToOne = (fileId: string) => {
    setSelectedPages([fileId]);
  };

  const selectAllPages = () => {
    if (!msSite) {
      return;
    }

    setSelectedPages(
      msSite.pages && msSite.pages.length > 0
        ? msSite.pages.map((page: DriveResource) => {
            return page.id;
          })
        : ([] as string[])
    );
  };

  const handleSelectPages = () => {
    if (!msSite) {
      return;
    }

    const finalDriveResources: DriveResource[] = [];

    selectedPages.forEach((pageId: string) => {
      if (!msSite.pages) {
        return;
      }

      const index = msSite.pages.findIndex((page: DriveResource) => {
        return page.id == pageId;
      });

      if (index !== -1) {
        finalDriveResources.push({ ...msSite.pages[index] });
      }
    });

    onSelected(finalDriveResources);
  };

  console.log("[SharePointPagesPicker] mssite: ", msSite);

  return (
    <Modal
      isOpen={isOpen}
      style={null}
      onClose={onClose}
      canClose={false}
      allowClickout={true}>
      <div className="sharepoint-pages-picker-container">
        {msSite && (
          <>
            <div className="sharepoint-pages-picker-header">
              <div className="sharepoint-pages-picker-title">
                Pick Pages from: {msSite.name}
              </div>
              <div className="sharepoint-pages-picker-buttons">
                <div className="sharepoint-pages-picker-select">
                  <button onClick={handleSelectPages}>Select</button>
                </div>
                <div className="sharepoint-pages-picker-close">
                  <img className="icon-close" onClick={onClose} />
                </div>
              </div>
            </div>
            <div className="sharepoint-pages-picker-back">
              <div className="sharepoint-pages-picker-back-container">
                <div
                  className="sharepoint-pages-picker-arrow"
                  onClick={() => handleOpenSharepointPicker()}>
                  <img src="/icons/arrow_left.png" alt="" />
                </div>
              </div>
            </div>
            <div className="sharepoint-pages-picker-divider"></div>

            <div className="sharepoint-pages-picker-body">
              {msSite &&
                msSite.pages &&
                msSite.pages.map((page: DriveResource) => {
                  return (
                    <div
                      key={"page-" + page.id}
                      className={
                        pageIsSelected(page.id)
                          ? "sharepoint-pages-picker-page-selected"
                          : "sharepoint-pages-picker-page"
                      }
                      onClick={() => {
                        if (!multiKeyDown) {
                          resetSelectedPagesToOne(page.id);
                          return;
                        }

                        if (pageIsSelected(page.id)) {
                          unselectPage(page.id);
                        } else {
                          selectPage(page.id);
                        }
                      }}>
                      <div className="sharepoint-pages-picker-icon">
                        <img src="/icons/light-mode/app_logos/aspxpage.svg" />
                      </div>
                      <div className="sharepoint-pages-picker-name">
                        {page.name}.aspx
                      </div>
                    </div>
                  );
                })}
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};
